import React from 'react';
import AboutMe from './AboutMe/AboutMe';
import Banner from './Banner/Banner';
import Contact from './Contact/Contact';
import './Home.css';
import Projects from './Projects/Projects';
// import Skills from './Skills/Skills';

const Home = () => {
    return (
        <>
            <Banner />
            {/* <Skills /> */}
            <AboutMe />
            <Projects />
            <Contact />
        </>
    );
};

export default Home;